import { deleteField } from "@angular/fire/firestore";
import { ContextMembership, FirestoreUser, IUser } from "diwimamodelweb/lib";

export const anyToUser = (element: IUser) => {
    const {contextId, identifier, roles, displayName, email, updateTimestamp, creationDate,
        firstName,
        lastName,
        gender,
        salutation,
        title,
        legalAddress,
        signature,
        invitationState,
        language,
        contextMembership,
        contextIds,
        telephone,
        userGroupIds,
        selectedContextId,
        pushNotifications,
    } = element as any
    let user = new FirestoreUser()
    user.contextId = contextId
    user.identifier = identifier
    user.displayName = displayName
    user.email = email
    user.roles = roles
    user.updateTimestamp = updateTimestamp
    user.creationDate = creationDate
    user.firstName = firstName
    user.lastName = lastName
    user.gender = gender
    user.salutation = salutation
    user.title = title
    user.legalAddress = legalAddress
    user.signature = signature
    user.telephone = telephone
    user.invitationState = invitationState
    user.language = language
    user.contextMembership = contextMembership
    user.contextIds = contextIds
    user.userGroupIds = userGroupIds
    user.selectedContextId = selectedContextId
    ;(user as any).pushNotifications = pushNotifications
    return user
}

export const anyToContextMembershipUser = (element: any) => {
    const {contextId, identifier, roles,
        contextName, _structureVersion, 
        additionalRights,updateTimestamp,
        huntingEventManagement,
        invitationState,userId,
         creationDate,email,name} = element
    let membership = new ContextMembership()
    membership.contextName = contextName
    membership.identifier = identifier
    membership.roles = roles
    membership.additionalRights = additionalRights
    membership._structureVersion = _structureVersion
    membership.updateTimestamp = updateTimestamp
    membership.huntingEventManagement = huntingEventManagement
    membership.invitationState = invitationState
    membership.userId = userId
    membership.email = email
    membership.creationDate = creationDate

    return membership
}


/**
 * Notification-channel prefs for one context, with fallback to the old,
 * non-context-aware structure.
 *
 * Old:  user.pushNotificationChannels: string[]  — event keys, "enabled" meant
 *       push (the only channel that existed then), and applied to every context
 *       alike since there was no per-context concept at all.
 * New:  user.pushNotifications[contextId][event].channels: ('mail'|'push')[]
 *
 */
export const resolveNotificationContextPrefs = (
    user: any,
    contextId: string | null | undefined,
): Record<string, { channels: string[] }> => {
    const migrated = contextId ? user?.pushNotifications?.[contextId] : undefined
    if (migrated) return migrated

    const legacy: string[] = user?.pushNotificationChannels ?? []
    const fallback: Record<string, { channels: string[] }> = {}
    legacy.forEach((eventKey: string) => { fallback[eventKey] = { channels: ['push'] } })
    return fallback
}

export const updatesToFirestoreUpdates = (updates:any): any => {
    let map: any = {}
    for (let [key, value] of Object.entries(updates)) {
        const {newValue} = value as any
        map[key] = newValue ? newValue : deleteField()
    }
    // updates.forEach((value, key) => {
    //     const {newValue} = value
    //     map[key] = newValue ? newValue : firebase.default.firestore.FieldValue.delete()
    // })
    return map
}


const supercontextSelection = `diwima.superContext.selection`

export function readLastSelection(contextId: string, userId: string): string | null {
  if (!contextId) return null;
  if(!userId) return null;
  try {
    const raw = localStorage.getItem(supercontextSelection);
    const map = raw ? JSON.parse(raw) : {};
    const selection = map?.[`${userId}.${contextId}`] ?? null;
    return selection;
  } catch { return null; }
}

export function saveSelection(contextId: string, ids: string[], userId:String) {
  if(!userId) return null;
  if (!contextId) return null;
  try {
    const last = localStorage.getItem(supercontextSelection);
    const map = last ? JSON.parse(last) : {};
    const data = {
      contextId: contextId,
      selected: ids
    }
    map[`${userId}.${contextId}`] = data;
    localStorage.setItem(supercontextSelection, JSON.stringify(map));
  } catch { }


}
